import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtOI(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v);
  return a >= 1e7 ? (v / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? (v / 1e5).toFixed(1) + 'L' : String(Math.round(v));
}

var OIWalls3xLiveM = function () {
  var [state, setState] = useState(null);
  var [busy, setBusy] = useState(false);

  var fetchState = useCallback(function () {
    fetch(API + '/oiwalls3x-live/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) setState(d);
    }).catch(function () {});
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 1000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  function post(path) {
    setBusy(true);
    fetch(API + path, { method: 'POST' }).then(function () {
      setBusy(false); setTimeout(fetchState, 500);
    }).catch(function () { setBusy(false); });
  }

  var cfg = (state && state.config) || {};
  var walls = (state && state.walls) || {};
  var legs = (state && state.legs) || [];
  var st = (state && state.stats) || {};
  var events = (state && state.events) || [];
  var enabled = !!(state && state.enabled);
  var dryRun = !!(state && state.dry_run);
  var openLegs = legs.filter(function (l) { return l.status === 'open'; });
  var card = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px', marginBottom: 10 };

  return (
    <div style={{ padding: '14px 14px 80px', color: '#e5e7eb', fontFamily: 'inherit', height: '100%', overflowY: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, flexWrap: 'wrap', marginBottom: 4 }}>
        <span style={{ fontSize: 18, fontWeight: 800 }}>🧱 Walls 3x LIVE</span>
                {dryRun ? (
          <span style={{ fontSize: 8, fontWeight: 800, letterSpacing: 1, color: '#fbbf24', background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.5)', borderRadius: 6, padding: '2px 6px' }}>DRY RUN</span>
        ) : null}
        <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: enabled ? '#22c55e' : '#6b7a8d' }}>{enabled ? '● ON' : '○ OFF'}</span>
        {state && state.hedges_open && !state.active && !state.entered_today ? <span style={{ fontSize: 8, fontWeight: 800, color: '#22c55e', background: 'rgba(34,197,94,0.12)', border: '1px solid rgba(34,197,94,0.5)', borderRadius: 6, padding: '2px 6px' }}>HEDGES IN ✓</span> : null}
        {state && state.hedges_open && !state.active && state.entered_today ? <span style={{ fontSize: 8, fontWeight: 800, color: '#a78bfa', background: 'rgba(167,139,250,0.12)', border: '1px solid rgba(167,139,250,0.5)', borderRadius: 6, padding: '2px 6px' }}>HEDGES HELD</span> : null}
        {state && state.disabled_for_day ? <span style={{ fontSize: 8, fontWeight: 800, color: '#ef4444', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.45)', borderRadius: 6, padding: '2px 6px' }}>BREAKER</span> : null}
        {state && state.weekday_ok === false ? <span style={{ fontSize: 8, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.5)', borderRadius: 6, padding: '2px 6px' }}>{String(state.weekday_today || 'TODAY').slice(0,3).toUpperCase()} OFF</span> : null}
        {state && (state.net_zero_sides || []).length ? <span style={{ fontSize: 8, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.5)', borderRadius: 6, padding: '2px 6px' }}>ON WING {(state.net_zero_sides || []).join('+')}</span> : null}
      </div>
      <div style={{ fontSize: 9, color: '#6b7a8d', marginBottom: 12 }}>
        {cfg.lots || 1}L/leg · hedge {(cfg.lots || 1) * (cfg.walls_per_side || 3)}L/wing · {cfg.product || 'MIS'} · hdg {cfg.hedge_entry_time || '09:16'} · sell {cfg.entry_time || '09:17'} · exit {cfg.exit_time || '15:00'}
        {state && state.day_stopped ? ' · stopped: ' + state.day_stopped : ''} · settings on desktop
      </div>

      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 8 }}>
          WALLS · ATM {walls.atm || '--'} · {walls.time || '--'}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {[['CE', walls.ce_top || (walls.ce ? [walls.ce] : []), '#ef4444'], ['PE', walls.pe_top || (walls.pe ? [walls.pe] : []), '#22c55e']].map(function (g) {
            var held = openLegs.filter(function (l) { return l.role === 'sell' && l.type === g[0]; }).map(function (l) { return l.strike; });
            return (
              <div key={g[0]} style={{ flex: 1, background: '#0d1524', borderRadius: 8, padding: '8px 10px' }}>
                <div style={{ fontSize: 8, fontWeight: 800, color: g[2], textAlign: 'center', marginBottom: 4 }}>{g[0]} WALLS</div>
                {g[1].length ? g[1].map(function (w, i) {
                  var h = held.indexOf(w.strike) > -1;
                  return (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontWeight: 800, padding: '2px 0' }}>
                      <span>{w.strike}{h ? <span style={{ fontSize: 8, color: '#22c55e', marginLeft: 4 }}>✓</span> : null}</span>
                      <span style={{ fontSize: 10, color: g[2] }}>{fmtOI(w.oi)}</span>
                    </div>
                  );
                }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center' }}>--</div>}
              </div>
            );
          })}
        </div>
      </div>

      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>
            LEGS{legs.length ? ' · ' + openLegs.length + '/' + legs.length + ' open' : ''}
          </span>
          {legs.length ? <span style={{ fontSize: 12, fontWeight: 800, color: (st.day_pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(st.day_pnl)}</span> : null}
        </div>
        {legs.length ? legs.map(function (l, i) {
          var closed = l.status === 'closed';
          return (
            <div key={i} style={{ fontSize: 10, color: closed ? '#556677' : '#8b98a9', padding: '3px 0', textDecoration: closed ? 'line-through' : 'none' }}>
              <span style={{ fontWeight: 800, color: l.role === 'hedge' ? '#a78bfa' : '#ef4444' }}>{l.role === 'hedge' ? 'HDG' : 'SELL'}</span>{' '}
              {l.strike} {l.type} @ {l.entry_price} → {closed ? l.exit_price : l.ltp}
              <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl)}</span>
            </div>
          );
        }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '10px 0' }}>
          {state && state.weekday_ok === false
            ? (state.weekday_today || 'Today') + ' is unticked in Trading Days — no entry today.'
            : enabled ? 'Flat — enters at ' + (cfg.entry_time || '09:17') + '.' : 'Disabled.'}
        </div>}
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {[['DAY', st.day_pnl], ['REAL', st.realized], ['UNREAL', st.unrealized]].map(function (x, i) {
          return (
            <div key={i} style={{ flex: 1, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '7px 4px', textAlign: 'center' }}>
              <div style={{ fontSize: 8, fontWeight: 800, color: '#556677' }}>{x[0]}</div>
              <div style={{ fontSize: 13, fontWeight: 800, color: (x[1] || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(x[1])}</div>
            </div>
          );
        })}
        <div style={{ flex: 1, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '7px 4px', textAlign: 'center' }}>
          <div style={{ fontSize: 8, fontWeight: 800, color: '#556677' }}>ROLLS</div>
          <div style={{ fontSize: 13, fontWeight: 800, color: '#fbbf24' }}>{(st.rolls_ce || 0) + (st.rolls_pe || 0)}</div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <button onClick={function () { post('/oiwalls3x-live/' + (enabled ? 'disable' : 'enable')); }} disabled={busy}
          style={{ flex: 1, fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '11px 0',
            background: enabled ? 'rgba(239,68,68,0.12)' : 'rgba(34,197,94,0.12)',
            color: enabled ? '#ef4444' : '#22c55e',
            border: '1px solid ' + (enabled ? 'rgba(239,68,68,0.5)' : 'rgba(34,197,94,0.5)') }}>
          {busy ? '\u2026' : enabled ? 'Disable' : 'Enable'}
        </button>
        <button onClick={function () { post('/oiwalls3x-live/exit'); }} disabled={busy || !openLegs.length}
          style={{ flex: 1, fontSize: 12, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '11px 0',
            background: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: '1px solid rgba(251,191,36,0.5)',
            opacity: openLegs.length ? 1 : 0.4 }}>
          Exit now
        </button>
      </div>

      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 8 }}>ACTIVITY</div>
        <div style={{ maxHeight: 260, overflowY: 'auto' }}>
          {events.length ? events.slice().reverse().map(function (ev, i) {
            var col = ev.level === 'error' ? '#ef4444' : ev.level === 'warning' ? '#fbbf24' : ev.level === 'success' ? '#22c55e' : '#8b98a9';
            return <div key={i} style={{ fontSize: 9, color: col, padding: '3px 0', borderBottom: '1px solid #0d1524' }}>
              <span style={{ color: '#556677' }}>{ev.time}</span> {ev.text}
            </div>;
          }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '8px 0' }}>Quiet.</div>}
        </div>
      </div>
    </div>
  );
};

export default OIWalls3xLiveM;
